import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64375738"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ion-margin ion-padding-bottom" }, " Select Plan ", -1))
const _hoisted_2 = { class: "ion-margin" }
const _hoisted_3 = { class: "ion-margin" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "ion-margin" }
const _hoisted_7 = { class: "ion-margin" }
const _hoisted_8 = { class: "ion-margin" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  class: "text_no_decoration terms_and_privacy",
  href: "https://www.apple.com/legal/internet-services/itunes/dev/stdeula/",
  target: "_blank"
}
const _hoisted_11 = {
  key: 1,
  class: "text_no_decoration terms_and_privacy"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "text_no_decoration terms_and_privacy",
  href: "https://beamian.com/terms/",
  target: "_blank"
}, "Privacy Policy", -1))

import {
  IonIcon,
  IonPage,
  IonContent,
  IonItem,
  IonLabel,
  IonLoading,
  IonList,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonRefresher,
  IonButton,
  IonRefresherContent,
  isPlatform,
  getPlatforms,
} from "@ionic/vue";
import { checkmarkSharp, copyOutline } from "ionicons/icons";
import { computed, reactive, onMounted, watch, toRaw } from "vue";
import { useAppStore } from "@/stores/app";
import { useUserStore } from "@/stores/user";
import { useToasters } from "@/composition/toasters";
import { useWindowWidth } from "@/composition/window";
import {
  Purchases,
  PurchasesPackage,
  LOG_LEVEL,
  PURCHASES_ERROR_CODE,
} from "@revenuecat/purchases-capacitor";
import { Clipboard } from "@capacitor/clipboard";

import { createClientPlan, storeCharge } from "@/api/plans";
// import { SubscriptionCard } from "@/views/Subscription/SubscriptionCard.vue";

export interface IParamsConfirmSubscription {
  store_name: string;
  plan_id: number;
  price: number;
  subscription_id: string;
  current_period_end: number;
  currency: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MySubscription',
  setup(__props) {

const { isMobile } = useWindowWidth();
const toasters = useToasters();
const userStore = useUserStore();
const appStore = useAppStore();

// Set this revenuecat variables as non reactive
// let package_to_subscribe: PurchasesPackage;

const dark_mode = computed(() => appStore.settings.theme === "dark");

const state = reactive({
  loading: false,
  payment_response: {},
  is_pro: false,
  plan_limits: {
    free: {
      Events: 1,
      Visitors: 500,
      "Event Managers": 3,
    },
    default: {},
    Plus: {},
    Starter: {},
  },
  plan_descriptions: {
    free: "The no-cost starter package designed to empower everyone with an intuitive check-in solution",
    default: "",
    Plus: "",
    Starter: "",
  },
  payment_plan_id: {
    default: null,
    Plus: null,
    Starter: null,
  },
  current_plan: {},
  billing_cycle: "MONTHLY",
  managementURL: "",
  status: "",
  plans: [],
  revenue_plans_raw: {},
  successfull_purchase: false,
  customerInfo: {},
  plataform: "",
  debug_steps: [""],
});

onMounted(async () => {
  getContextPlatform();
  await loadBaseInformation().then(async () => {
    await getCustomerInfo();
  });
});

watch(
  () => userStore.me.id,
  async () => {
    if (userStore.me.id) {
      await loadBaseInformation();
    }
  }
);

const loadBaseInformation = async () => {
  state.plans = [];
  try {
    await getSubscriptions().then(() => {
      const plan_keys = Object.keys(state.revenue_plans_raw.all);
      plan_keys.reverse().forEach((key) => {
        const package_data = state.revenue_plans_raw.all[key];
        state.plans = [...state.plans, ...package_data.availablePackages];
        state.plan_limits[key] = {
          Events: package_data.metadata.check_in_max_events,
          Visitors: package_data.metadata.check_in_max_capacity,
          "Event Managers": package_data.metadata.check_in_max_event_managers,
        };
        state.plan_descriptions[key] = package_data.serverDescription;
        state.payment_plan_id[key] = {
          monthly: package_data.metadata.monthly_payment_plan_id,
          annual: package_data.metadata.annual_payment_plan_id,
        };
      });
      getCustomerInfo();
    });
    state.loading = false;
  } catch (e) {
    toasters.addError("Error getting available subscriptions");
    state.loading = false;
  }
};

const getContextPlatform = () => {
  if (isPlatform("ios")) {
    state.plataform = "ios";
  }
  if (isPlatform("android")) {
    state.plataform = "android";
  }
  if (!state.plataform) {
    state.plataform = getPlatforms().join(",");
  }
};

const getCustomerInfo = async () => {
  try {
    await Purchases.getCustomerInfo().then((customerInfo) => {
      state.customerInfo = customerInfo;
      const active_subscriptions = Object.keys(
        customerInfo.customerInfo.entitlements.active
      );
      if (active_subscriptions.length) {
        // Get active subscription
        state.current_plan =
          customerInfo.customerInfo.entitlements.active[
          active_subscriptions[0]
          ];
        if (customerInfo.customerInfo.managementURL) {
          state.managementURL = customerInfo.customerInfo.managementURL;
        }
      }
    });
  } catch (e) {
    state.loading = false;
    throw e;
  }
};

const getSubscriptions = async () => {
  // state.loading = true;
  const googleApiKey = "goog_mwGkgkMqekKJwWbgNyacBCoMApA";
  const appleApiKey = "appl_IkbMXySFGfuZCmCInEumggLumSj";

  await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG }); // Enable to get debug logs

  try {
    if (state.plataform === "android") {
      await Purchases.configure({
        apiKey: googleApiKey,
        appUserID: userStore.related.clients[0].id.toString(),
      });
    }
    if (state.plataform.includes("ios")) {
      console.log("iOS platform!!!");
      await Purchases.configure({
        apiKey: appleApiKey,
        appUserID: userStore.related.clients[0].id.toString(),
      });
    }
  } catch (e) {
    state.loading = false;
    throw e;
  }
  await Purchases.getOfferings().then((offerings) => {
    state.revenue_plans_raw = offerings;
  });
  state.loading = false;
};

const getCurrentPlanName = () => {
  if (Object.keys(state.current_plan).length) {
    return (
      state.current_plan.productIdentifier +
      ":" +
      state.current_plan.productPlanIdentifier
    );
  } else {
    return "";
  }
};
const copy = async (txt: string) => {
  await Clipboard.write({
    string: txt,
  }).then(() => {
    toasters.addSuccess("Copied!");
  });
};

// const callExample = async () => {
//   const params = {
//     store_name: "Google Play",
//     plan_id: 37,
//     price: 12000,
//     subscription_id: "test-monthly-123",
//     current_period_end: 1703808000,
//   };
//   await confirmSubscription(params);
// };

const confirmSubscription = async (params: IParamsConfirmSubscription) => {
  state.debug_steps.push("ConfirmSubscription called");

  const cpp_payload = {
    client_account: userStore.related.clients[0].id,
    payment_plan: params.plan_id,
    billing_cycle: state.billing_cycle.toLowerCase(),
    payment_option: params.store_name,
    currency: params.currency,
  };
  createClientPlan(cpp_payload)
    .then((response) => {
      state.debug_steps.push(
        "createClientPlan called => status " + response.status
      );
      state.debug_steps.push("Preparing to confirm a store charge");

      const store_payload = {
        price: params.subscription_id.includes("starter")
          ? 12000
          : params.price,
        currency: params.currency,
        store: params.store_name.replace(" ", ""),
        subscription_status: "active",
        subscription_id: params.subscription_id,
        current_period_end: params.current_period_end,
      };
      const client_payment_plan = response.data.id;
      storeCharge(client_payment_plan, store_payload)
        .then(async (response_store_charge) => {
          state.debug_steps.push(
            "storeCharge called => status " + response_store_charge.status
          );
          state.debug_steps.push("New plan subscribed successfully!");
          toasters.addSuccess("New plan subscribed successfully!");
          await loadBaseInformation(); // reload data to reflect changes
        })
        .catch((err) => {
          state.debug_steps.push(
            "storeCharge error => " + JSON.stringify(err.response)
          );
          toasters.addError("Error while confirming a new subscription");
        });
    })
    .catch((err) => {
      state.debug_steps.push(
        "Error while creating a Client Payment Plan => " +
        JSON.stringify(err.response)
      );
      toasters.addError("Error while updating customer plan");
    });
};

const WarningOnlyOneActivePlanAllowed = () => {
  toasters.addWarning("You can only have one active subscription at a time.");
};

const subscribePlan = async (
  pack: PurchasesPackage,
  plan_identifier: string,
  plan_price: number
) => {
  state.debug_steps.push("Click to subscribe plan => " + plan_identifier);
  console.log("Click to subscribe plan => " + plan_identifier);

  try {
    if (Object.keys(state.current_plan).length) {
      WarningOnlyOneActivePlanAllowed();
    } else {
      let payment_plan_id: number;

      if (state.billing_cycle === "MONTHLY") {
        payment_plan_id = state.payment_plan_id[plan_identifier].monthly;
      } else {
        payment_plan_id = state.payment_plan_id[plan_identifier].annual;
      }
      if (payment_plan_id) {
        console.log(
          "Before purchase => payment_plan_id " + payment_plan_id.toString()
        );
        await Purchases.purchasePackage({
          aPackage: toRaw(pack),
        }).then(async (purchaseResult) => {
          state.debug_steps.push(
            "Subscribed => " +
            purchaseResult.customerInfo.activeSubscriptions[0]
          );
          console.log(
            "Subscribed => " +
            purchaseResult.customerInfo.activeSubscriptions[0]
          );

          state.debug_steps.push(
            "CustomerInfo active plans => " +
            Object.keys(purchaseResult.customerInfo.entitlements.active).join(
              ", "
            )
          );
          console.log(
            "CustomerInfo active plans => " +
            Object.keys(purchaseResult.customerInfo.entitlements.active).join(
              ", "
            )
          );

          let active_plan_name =
            pack.offeringIdentifier === "default"
              ? "premium"
              : pack.offeringIdentifier;

          console.log(
            "Trying to get active plan => " + active_plan_name.toLowerCase()
          );

          const active_plan =
            purchaseResult.customerInfo.entitlements.active[
            active_plan_name.toLowerCase()
            ];

          state.debug_steps.push(
            "Expiration date (ms) => " + active_plan.expirationDateMillis
          );

          const store_origin = active_plan.store;
          state.debug_steps.push("Store origin => " + store_origin);

          let store_name =
            store_origin === "PLAY_STORE" ? "Google Play" : "Apple App Store";

          state.debug_steps.push("Store name => " + store_name);

          state.debug_steps.push(
            "Preparing to create a new client-payment-plan"
          );

          const params = {
            store_name: store_name,
            plan_id: payment_plan_id,
            price: plan_price * 100,
            subscription_id: purchaseResult.customerInfo.activeSubscriptions[0],
            current_period_end: active_plan.expirationDateMillis / 1000,
            subscription_name:
              purchaseResult.customerInfo.activeSubscriptions[0],
            currency: pack.product.currencyCode.toLowerCase(),
          };

          // Confirm subscription to our backend
          await confirmSubscription(params);
          // Reload data to reflect changes
          await loadBaseInformation();
        });
      }
    }
  } catch (error: any) {
    console.log("PurchasePackage error");
    console.log(error);
    state.loading = false;
    if (error.code === PURCHASES_ERROR_CODE.PURCHASE_CANCELLED_ERROR) {
      // Purchase cancelled
    } else {
      // Error making purchase
    }
  }
};

const handleRefresh = async (event: any) => {
  await loadBaseInformation();
  if (event.target) {
    event.target.complete();
  }
};

// const selectBillingCycle = (type: string) => {
//   state.billing_cycle = type;
// };

return (_ctx: any,_cache: any) => {
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonContent), { key: 0 }, {
            default: _withCtx(() => [
              _hoisted_1,
              (_unref(isMobile))
                ? (_openBlock(), _createBlock(_unref(IonRefresher), {
                    key: 0,
                    slot: "fixed",
                    onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (handleRefresh($event)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonRefresherContent))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (state.plans.length)
                ? (_openBlock(), _createBlock(_unref(IonCard), {
                    key: 1,
                    class: "ion-margin"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCardHeader), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCardTitle), null, {
                            default: _withCtx(() => [
                              _createTextVNode("Free Plan")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonCardSubtitle), {
                            class: _normalizeClass(dark_mode.value ? 'dark_mode_price' : '')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("€ 0 ")
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_2, [
                        (Object.keys(state.current_plan).length === 0)
                          ? (_openBlock(), _createBlock(_unref(IonButton), {
                              key: 0,
                              fill: "outline",
                              class: "select_plan_button"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Currently subscribed")
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_unref(IonButton), {
                              key: 1,
                              class: "select_plan_button",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (WarningOnlyOneActivePlanAllowed()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Select Free Plan")
                              ]),
                              _: 1
                            }))
                      ]),
                      _createVNode(_unref(IonList), { inset: true }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.plan_limits.free, (limit, i) => {
                            return (_openBlock(), _createBlock(_unref(IonItem), {
                              class: _normalizeClass(dark_mode.value ? 'dark_mode_item limits' : 'limits'),
                              key: limit
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  "aria-hidden": "true",
                                  icon: _unref(checkmarkSharp),
                                  color: "success",
                                  slot: "start"
                                }, null, 8, ["icon"]),
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(limit) + " " + _toDisplayString(i), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["class"]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("h6", _hoisted_3, _toDisplayString(state.plan_descriptions.free), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.plans.filter(
      (plan) => plan.packageType === state.billing_cycle
    ), (plan) => {
                return (_openBlock(), _createBlock(_unref(IonCard), {
                  class: "ion-margin",
                  key: plan
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardHeader), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCardTitle), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(plan.product.title.replace("(Check-in by beamian)", "")), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (plan.product.priceString)
                          ? (_openBlock(), _createBlock(_unref(IonCardSubtitle), {
                              key: 0,
                              class: _normalizeClass(dark_mode.value ? 'dark_mode_price' : '')
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(plan.product.priceString) + " ", 1),
                                (plan.packageType === 'ANNUAL')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "/ year"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_5, "/ month"))
                              ]),
                              _: 2
                            }, 1032, ["class"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_6, [
                      (getCurrentPlanName() === plan.product.identifier)
                        ? (_openBlock(), _createBlock(_unref(IonButton), {
                            key: 0,
                            fill: "outline",
                            class: "select_plan_button"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Currently subscribed")
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_unref(IonButton), {
                            key: 1,
                            class: "select_plan_button",
                            onClick: ($event: any) => (
      subscribePlan(plan, plan.offeringIdentifier, plan.product.price)
      )
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Select " + _toDisplayString(plan.product.title.replace("(Event Check-In App)", "")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                    ]),
                    _createVNode(_unref(IonList), { inset: true }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.plan_limits[plan.offeringIdentifier], (limit, i) => {
                          return (_openBlock(), _createBlock(_unref(IonItem), {
                            class: _normalizeClass(dark_mode.value ? 'dark_mode_item limits' : 'limits'),
                            key: limit
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                "aria-hidden": "true",
                                icon: _unref(checkmarkSharp),
                                color: "success",
                                slot: "start"
                              }, null, 8, ["icon"]),
                              _createVNode(_unref(IonLabel), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(limit) + " " + _toDisplayString(i), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["class"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("h6", _hoisted_7, _toDisplayString(state.plan_descriptions[plan.offeringIdentifier]), 1),
                    _createElementVNode("div", _hoisted_8, [
                      (getCurrentPlanName() === plan.product.identifier)
                        ? (_openBlock(), _createBlock(_unref(IonButton), {
                            key: 0,
                            fill: "clear",
                            class: "select_plan_button"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                href: `${state.managementURL}`,
                                target: "_blank",
                                class: "text_no_decoration"
                              }, " Manage Subscription ", 8, _hoisted_9)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (state.plans.length)
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 2,
                    class: "ion-justify-content-center ion-margin"
                  }, {
                    default: _withCtx(() => [
                      (state.plataform === 'ios')
                        ? (_openBlock(), _createElementBlock("a", _hoisted_10, "Terms of Service"))
                        : _createCommentVNode("", true),
                      (state.plataform === 'ios')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, " and "))
                        : _createCommentVNode("", true),
                      _hoisted_12
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(IonLoading), {
                "is-open": state.loading,
                message: "Please wait..."
              }, null, 8, ["is-open"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})